import React, { FC, useCallback, useEffect } from "react";
import { useStore, landscapePoints, portraitPoints } from '../store'
import oTag from '../assets/images/otag.png';
import bottomBarImg from "../assets/images/bottomBar.png";
import logoImg from "../assets/images/logo.png";
import { motion } from "framer-motion";
import { Flex } from "@chakra-ui/react";
import { useDetectGPU } from "@react-three/drei";
import { MtmLanding } from "./MtmLanding";
import { Vector3 } from "three";

const Overlay: FC= () => {
  const isBlurred = useStore((state) => state.isBlurred)
  const isLoading = useStore((state) => state.isLoading)
  const { width, height } = useStore((state) => state.windowDimensions)
  const isLandingBlurred = useStore((state) => state.isLandingBlurred)
  const selectedPersona = useStore((state) => state.selectedPersona)
  const setIsBlurred = useStore((state) => state.setIsBlurred)
  const setIsLandingBlur = useStore((state) => state.setIsLandingBlur)
  const setWindowDimensions = useStore((state) => state.setWindowDimensions)
  const setRunAnimations = useStore((state) => state.setRunAnimations)
  const setDisabledAnchorPoints = useStore((state) => state.setDisabledAnchorPoints)
  const setSelectedAnchorPosition = useStore((state) => state.setSelectedAnchorPosition)

  const GPUTier = useDetectGPU()

  // used for setting the disabled anchor points based off screen size
  const handleSettingPoints = useCallback(() => {
    if(window.innerWidth <= 1024) {
      setDisabledAnchorPoints(portraitPoints)
    } else {
      setDisabledAnchorPoints(landscapePoints)
    }
  }, [setDisabledAnchorPoints])

  useEffect(() => {
    const canvas = document.querySelector("canvas");

    if (canvas) {
      const blur = isLandingBlurred ? "blur(25px)" : isBlurred ? "blur(2px)" : ''
      canvas.style.filter = blur;
    }
  }, [isBlurred, isLandingBlurred]);

  const handleResize = useCallback(() => {
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    })



    handleSettingPoints()
  }, [setWindowDimensions, handleSettingPoints, setSelectedAnchorPosition])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize, height, width])

  useEffect(() => {
    if(GPUTier.tier <= 1) {
      setRunAnimations(false)
    }

  }, [GPUTier.tier, setRunAnimations])

  const handleToggleLanding = () => {
      if(!selectedPersona){
        setIsBlurred(!isBlurred)
        setIsLandingBlur(!isLandingBlurred)
      }
  }

  const variants = {
    active: {
      opacity: 1,
      scale: 1,
      transition: {
        delay: 0.2,
      }
    },
    hide: {
      opacity: 0,
      scale: 0,
      transition: {
        duration: 0.2
      }
    }
  }
  return (
      <MotionFlex
        pointerEvents={isLandingBlurred ? '' : 'none'}
        backgroundColor={`rgba(212, 207, 202, ${isLandingBlurred || isBlurred ? '0.75' : '0'})`}
        cursor="pointer"
        position="fixed"
        top="0"
        left="0"
        width="100vw"
        height="100vh"
        onPointerUp={handleToggleLanding}
      >
          <MotionFlex
            margin="0 auto"
            flexDirection="column"
            boxShadow="0px 20px 70px 10px #CCC6C200"
            animate={!isLoading && isLandingBlurred ? 'active' : 'hide'}
            variants={variants}
            justifyContent="center"
            alignItems="center"
            pointerEvents="all"
          >
            <MtmLanding />
          </MotionFlex>
        {!isLandingBlurred && (
          <>
            <MotionFlex
                animate={{
                opacity: selectedPersona ? 0 : 1
              }}>
              <button className="overlay__backButton"
                      style={{ pointerEvents: "all" }}
                      disabled={isBlurred} aria-label="go back"
                      onPointerUp={handleToggleLanding}>
                <img src={logoImg} alt="logo" />
              </button>
            </MotionFlex>
            <img
              className="overlay__bottomBar"
              src={bottomBarImg}
              alt="bottom bar"
              width="100%"
            />
            <img
                className="oTag"
                src={oTag}
                // ToDo: Look for preferred O-Tag alt
                alt={"Oracle"}
            />
          </>
        )
      }
      </MotionFlex>
  );
};

const MotionFlex = motion(Flex);

export { Overlay }
